import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import './Dialogs.scss';

interface EnrollDeviceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onGenerateCode: () => void;
}

const EnrollDeviceDialog: React.FC<EnrollDeviceDialogProps> = ({ isOpen, onClose, onGenerateCode }) => {
  if (!isOpen) return null;

  return (
    <Dialog title="Enroll new device" onClose={onClose} width={500}>
      <div className="offboard-dialog-content">
        <p className="offboard-dialog-text">
          In case of lost or broken device, you can enroll a new one. <br></br>To proceed with this, you need to
          <b> generate a new ID code</b>, which should be <b>handed over to the participant</b> or simply{' '}
          <b>entered into the tablet app</b>. <br></br>
          <br></br>The participant will be able to continue the study from the next available session.
        </p>

        <div className="offboard-button-container">
          <button
            className="dashboard-button offboard-dialog-button primary-button"
            onClick={onGenerateCode}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ marginRight: '8px', flexShrink: 0 }}
            >
              <path d="M1 4v6h6" />
              <path d="M23 20v-6h-6" />
              <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" />
            </svg>
            <span>Generate new code</span>
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default EnrollDeviceDialog;
